import { ReactNode } from 'react'
import cx from 'classnames'

interface CollectionChipProps {
  title: string
  icon?: ReactNode
  label?: string
  onClick?: () => void
  className?: string
  children?: ReactNode
}

const CollectionChip = ({
  label,
  icon,
  title,
  onClick = () => null,
  className,
  children,
}: CollectionChipProps) => {
  if (!children) {
    return null
  }

  return (
    <button
      onClick={onClick}
      aria-label={label}
      title={title}
      className={cx(
        'inline-flex items-center justify-center align-middle bg-pageBG text-pageText rounded-full p-2 border',
        'group',
        className,
      )}
    >
      <span className="px-2 max-w-[10rem] overflow-hidden overflow-ellipsis">
        {children}
      </span>
      {icon && (
        <span className="text-sm p-1 -my-2 -mx-1 rounded-full transition-colors duration-300 bg-pageText bg-opacity-0 group-hover:bg-opacity-20">
          {icon}
        </span>
      )}
    </button>
  )
}

export default CollectionChip
